module.exports = __webpack_public_path__ + "img/icons-180.83e5c2b3.svg";